import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import type { Product } from '../api/product/types';
import { CheckoutButton } from './CheckoutButton';
import { getGALabelsWrapped } from './gtm/gtmLabels';
import { gtmPromotionView } from './gtm/gtmPromotions';
import { extractUrlParameters } from './urlUtils';

interface Props {
    disabled: boolean;
    product?: Product;
}

export const BuyButtonButton = ({ disabled, product }: Props) => {
    const intl = useIntl();
    useEffect(gtmPromotionView, []);
    const { noButtonText, textOnly, notResponsive } = extractUrlParameters(window.location.href);

    const isResponsive = !notResponsive;
    const isTextOnly = !!textOnly;

    const tooltip = disabled ? intl.formatMessage({ id: 'intl-msg:marketplace.buybutton.notBookable' }) : undefined;

    const btnTypeClass = isTextOnly ? '' : 'btn btn-primary';
    const baseClasses = btnTypeClass + (disabled ? ' disabled' : '');
    const gaLabels = disabled ? undefined : getGALabelsWrapped();

    return (
        <div className={'buyButtonLink'} title={tooltip} {...gaLabels?.view}>
            {isResponsive && (
                <CheckoutButton
                    product={product}
                    className={`${baseClasses} btn-icon-only visible-xs`}
                    disabled={disabled}
                    noText={true}
                    textOnly={isTextOnly}
                />
            )}
            {/* Match visible-xs's 300px cutoff; hidden-xs overlaps it at the boundary. */}
            <CheckoutButton
                product={product}
                className={`${baseClasses}${isResponsive && !isTextOnly ? ' display-none display-inline-flex-ls' : ''}${
                    noButtonText ? ' btn-icon-only' : ''
                }`}
                disabled={disabled}
                noText={!!noButtonText}
                textOnly={isTextOnly}
            />
        </div>
    );
};
